module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "marquee-scroll"
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "marquee-wrapper"
  }, [_c('div', {
    ref: "content",
    staticClass: "marquee-content",
    style: (_vm.contentStyle)
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "marquee-content",
    style: (_vm.contentStyle),
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75bd3710"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarqueeScroll.vue
// module id = 1021
// module chunks = 3